import {
  Jawwal10, Jawwal15, Jawwal20, Jawwal25, Jawwal30, Jawwal35,
  Jawwal40, Jawwal45, Jawwal50, Jawwal60, Jawwal70, Jawwal80,
  Jawwal90, Jawwal100, Jawwal200, JawwalEmpty
} from "./jawwal_base64";

export const EMPTY_JAWWAL_CREDIT = {
  dis: "",
  price: "0000",
  url: JawwalEmpty,
  id: "0000",
  flexiblePrice: true,
  type: "creditEmpty",
};

const JAWWAL_CREDITS = [
  {
    dis: "",
    price: "10",
    url: Jawwal10,
    id: "0010",
    type: "credit",
  },
  {
    dis: "",
    price: "15",
    url: Jawwal15,
    id: "0015",
    type: "credit",
  },
  {
    dis: "",
    price: "20",
    url: Jawwal20,
    id: "0020",
    type: "credit",
  },
  {
    dis: "",
    price: "25",
    url: Jawwal25,
    id: "0025",
    type: "credit",
  },
  {
    dis: "",
    price: "30",
    url: Jawwal30,
    id: "0030",
    type: "credit",
  },
  {
    dis: "",
    price: "35",
    url: Jawwal35,
    id: "0035",
    type: "credit",
  },
  {
    dis: "",
    price: "40",
    url: Jawwal40,
    id: "0040",
    type: "credit",
  },
  {
    dis: "",
    price: "45",
    url: Jawwal45,
    id: "0045",
    type: "credit",
  },
  {
    dis: "",
    price: "50",
    url: Jawwal50,
    id: "0050",
    type: "credit",
  },
  {
    dis: "",
    price: "60",
    url: Jawwal60,
    id: "0060",
    type: "credit",
  },
  {
    dis: "",
    price: "70",
    url: Jawwal70,
    id: "0070",
    type: "credit",
  },
  {
    dis: "",
    price: "80",
    url: Jawwal80,
    id: "0080",
    type: "credit",
  },
  {
    dis: "",
    price: "90",
    url: Jawwal90,
    id: "0090",
    type: "credit",
  },
  {
    dis: "",
    price: "100",
    url: Jawwal100,
    id: "00100",
    type: "credit",
  },
  {
    dis: "",
    price: "200",
    url: Jawwal200,
    id: "00200",
    type: "credit",
  },
];
export default JAWWAL_CREDITS;

export { EMPTY_JAWWAL_CREDIT as EMPTY_CREDIT };
